// Admin plan configs list query. Plans are platform-wide, the list is small
// (a handful of rows), and every mutation refetches the whole list — no
// pagination, unlike users/workspaces.
import { useQuery } from '@tanstack/react-query';

import { useIsPlatformAdmin } from '../../../shared/scope/useCurrentScope.js';

import { getAdminPlansQueryKey, listAdminPlans } from '../api/admin.client.js';

export function useAdminPlans() {
  const isPlatformAdmin = useIsPlatformAdmin();

  return useQuery({
    queryKey: getAdminPlansQueryKey(),
    queryFn: () => listAdminPlans(),
    enabled: isPlatformAdmin,
  });
}
